import { render, staticRenderFns } from "./CouponIcon.vue?vue&type=template&id=bdcfe63e&scoped=true"
import script from "./CouponIcon.vue?vue&type=script&lang=js"
export * from "./CouponIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcfe63e",
  null
  
)

export default component.exports